// extracted by mini-css-extract-plugin
export default {"label":"Login_label__7PUky","error":"Login_error__epM29","disbaleBtn":"Login_disbaleBtn__n9-BQ","textIntro":"Login_textIntro__2O8pY"};